import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { CommonForm } from './CommonForm'
import { Schema, schema, schemaDefault } from './schema'
import { useUpdateAdUnitUnfilledRecovery } from './useUpdateAdUnitUnfilledRecovery'

export const UnfilledRecoveryForm = (): JSX.Element => {
  const { adUnit, formId, loading, setTouched, setValid } = useContext(AddEditAdUnitContext)
  const { errors: apiErrors, update } = useUpdateAdUnitUnfilledRecovery()

  if (!adUnit) {
    return <Loading />
  }

  return (
    <Form<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(adUnit)}
    >
      {() => <CommonForm />}
    </Form>
  )
}
